<template>
    <profile-info-edit :onSave="updateProfile" :loading="isFetching"
        :profile="profile" :companyFullName="companyFullName"
        :orgTypes="orgTypes" />
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import ProfileInfoEdit from './ProfileInfoEdit';

export default {
    name: 'profile-edit-container',
    components: {
        ProfileInfoEdit,
    },
    data() {
        return {
            isFetching: false,
        }
    },
    methods: {
        ...mapActions('profile', ['fetchProfile', 'updateProfile']),
    },
    created() {
        if (!this.isFetched) {
            this.isFetching = true;
            this.fetchProfile()
                .then((res) => {
                    this.isFetching = false;
                })
                .catch((res) => {
                    this.isFetching = false;
                });
        }
    },
    computed: {
        ...mapGetters('orgTypes', ['orgTypes', 'individualId']),
        ...mapState('profile', ['isFetched']),
        ...mapGetters('profile', ['profile', 'companyFullName']),
    }
}
</script>



// WEBPACK FOOTER //
// ProfileInfoEditContainer.vue?30411c59